// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_loading__FhY4F{
    align-items: center;
    display: flex;
    height: 80vh;
    justify-content: center;
    width: 100vw;
  }

  /* styles.module.css */
.styles_container__\\+uwIk {
  margin: 0 2rem;
  padding: 1rem;
}

.styles_containerModal__KqMKU {
  padding: 5rem;
  width: 200rem;
  height: 100rem;
}

.styles_header__ArigY {
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.styles_title__R5ZOB {
  align-items: center;
  color: #18316e;
  display: flex;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  flex: 1 1;
}

.styles_filtrosContainer__Twrr0 {
  align-items: center;
  display: flex;
  width: 60%;
}

.styles_iconFilter__d32Dq {
  color: #18316e;
  font-size: 2rem;
  margin-right: 0.5rem;
}

.styles_tipoVisualizacaoContainer__t3jE6 {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0;
}

.styles_iconVisualizacoes__pCxaE {
  color: #18316e !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoes__pCxaE:hover {
  background-color: #bebebe !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  padding: 0.5rem !important;
}

.styles_iconVisualizacoesActive__YJdyx {
  background-color: #919191 !important;
  border-radius: 50% !important;
  color: white !important;
  cursor: pointer !important;
  font-size: 2.3rem !important;
  margin-left: 0.5rem !important;
  padding: 0.5rem !important;
}

.styles_spanDetalhes__XnLFM {
  font-weight: 700;
  color: #18316e;
  font-family: "Inter";
  font-size: 1.1rem;
}

.styles_textoDetalhes__Ts253 {
  color: #18316e;
  font-family: "Inter";
  font-size: 1.1rem;
}

.styles_visualizacaoContainer__NQfgX {
  padding: 1rem;
  overflow: auto;
  height: 55vh;
}

@media (max-width: 780px) {

  .styles_container__\\+uwIk {
    margin:0 1rem;
  }

  .styles_title__R5ZOB {
    align-self: flex-start;
  }

  .styles_filtrosContainer__Twrr0 {
    width: 100%;
    margin-bottom: 8px;
  }

  /* .tipoVisualizacaoContainer {
        width: 100%;
        justify-content: flex-end;
    } */

  .styles_header__ArigY {
    flex-direction: column;
  }
}

.styles_iconeAdd__6ooBG {
  color: #fff;
  font-size: 2rem;
}

.styles_iconeAdd__6ooBG:hover {
  color: #18316e;
}`, "",{"version":3,"sources":["webpack://./src/pages/ImportarSpeds/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,YAAY;EACd;;EAEA,sBAAsB;AACxB;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;;;OAGK;;EAEL;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".loading{\n    align-items: center;\n    display: flex;\n    height: 80vh;\n    justify-content: center;\n    width: 100vw;\n  }\n\n  /* styles.module.css */\n.container {\n  margin: 0 2rem;\n  padding: 1rem;\n}\n\n.containerModal {\n  padding: 5rem;\n  width: 200rem;\n  height: 100rem;\n}\n\n.header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.title {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  flex: 1;\n}\n\n.filtrosContainer {\n  align-items: center;\n  display: flex;\n  width: 60%;\n}\n\n.iconFilter {\n  color: #18316e;\n  font-size: 2rem;\n  margin-right: 0.5rem;\n}\n\n.tipoVisualizacaoContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 0;\n}\n\n.iconVisualizacoes {\n  color: #18316e !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoes:hover {\n  background-color: #bebebe !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  padding: 0.5rem !important;\n}\n\n.iconVisualizacoesActive {\n  background-color: #919191 !important;\n  border-radius: 50% !important;\n  color: white !important;\n  cursor: pointer !important;\n  font-size: 2.3rem !important;\n  margin-left: 0.5rem !important;\n  padding: 0.5rem !important;\n}\n\n.spanDetalhes {\n  font-weight: 700;\n  color: #18316e;\n  font-family: \"Inter\";\n  font-size: 1.1rem;\n}\n\n.textoDetalhes {\n  color: #18316e;\n  font-family: \"Inter\";\n  font-size: 1.1rem;\n}\n\n.visualizacaoContainer {\n  padding: 1rem;\n  overflow: auto;\n  height: 55vh;\n}\n\n@media (max-width: 780px) {\n\n  .container {\n    margin:0 1rem;\n  }\n\n  .title {\n    align-self: flex-start;\n  }\n\n  .filtrosContainer {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n\n  /* .tipoVisualizacaoContainer {\n        width: 100%;\n        justify-content: flex-end;\n    } */\n\n  .header {\n    flex-direction: column;\n  }\n}\n\n.iconeAdd {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.iconeAdd:hover {\n  color: #18316e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `styles_loading__FhY4F`,
	"container": `styles_container__+uwIk`,
	"containerModal": `styles_containerModal__KqMKU`,
	"header": `styles_header__ArigY`,
	"title": `styles_title__R5ZOB`,
	"filtrosContainer": `styles_filtrosContainer__Twrr0`,
	"iconFilter": `styles_iconFilter__d32Dq`,
	"tipoVisualizacaoContainer": `styles_tipoVisualizacaoContainer__t3jE6`,
	"iconVisualizacoes": `styles_iconVisualizacoes__pCxaE`,
	"iconVisualizacoesActive": `styles_iconVisualizacoesActive__YJdyx`,
	"spanDetalhes": `styles_spanDetalhes__XnLFM`,
	"textoDetalhes": `styles_textoDetalhes__Ts253`,
	"visualizacaoContainer": `styles_visualizacaoContainer__NQfgX`,
	"iconeAdd": `styles_iconeAdd__6ooBG`
};
export default ___CSS_LOADER_EXPORT___;
